<template>
  <div class="openSalesmanShopPage"
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">
    <XR-head titleText="开微店" :rightShow="false" ref="headObj"></XR-head>
   
    <img src="../../static/openSalesmanShop/all-bg.2025.jpg" style="width:100%;" />
		<!-- <div class="preferential">
			<p class="top">创<span>•</span>客<span>•</span>即<span>•</span>送</p>
			<div class="identity">
				<p>{{siteInfo.SiteName}}创客身份</p>
				<p>坐享<span class="seven">六大</span>收益</p>
			</div>
		</div>
		<div class="content">
			<div class="message">
				<div class="head">
					{{siteInfo.SiteName}}•创客权益
				</div>
				<div class="profit profit-one">
					<p>免代理费 免服务费</p>
				</div>
				<div class="profit profit-two">
					<p>赠送价值29998元的创客商城</p>
				</div>
				!--
				<div class="profit profit-three">
					<p>赠送价值59998元{{candyName}}挖宝矿机</p>
				</div>--
        		
				<div class="profit profit-three">
					<p>赠送{{candyName}}游戏淘宝机一台</p>
				</div>
				<div class="profit profit-four">
					<p>推荐会员在{{siteInfo.SiteName}}平台消费可获得消费产品PV20%零售利润</p>
				</div>
				<div class="profit profit-five">
					<p>推荐创客在{{siteInfo.SiteName}}平台进货可获得进货PV20%利润</p>
				</div>
				<div class="profit profit-six">
					<p>推荐创客在{{siteInfo.SiteName}}平台进货可获得进货的批发利润</p>
				</div>
				<div class="profit profit-seven">
					<p>享受{{siteInfo.SiteName}}会员所有权益</p>
				</div>
			</div>
		</div> -->
    <div class="bottom-bar" style="border-top:none;">
      <template v-if="isLogin">        
        <!-- <mu-raised-button label="开通创客" class="open-button" primary fullWidth to="/salesman/orderSubmit" v-if="isNotSalesman" />
        <mu-raised-button label="我的店铺" class="open-button" primary fullWidth to="/salesman/index" v-if="!isNotSalesman" /> -->
      </template>
      <mu-raised-button label="请先登录" class="open-button" primary fullWidth to="/login" v-if="!isLogin" />
      <mu-raised-button label="我要升级" class="open-button" primary fullWidth to="/salesman/salesmanProductIndex" v-if="isLogin" />
    </div>
    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
    export default {      
        data() {
            return {
              siteInfo:{
                SiteName:''
              },
              isLogin: false,
              isNotSalesman: false
            }
        },
        mounted() {
          this.$refs.XRtoast.load('加载中',true)
          this.getSiteInfo()
          this.getSalesmanInfo()
        },
        methods: {       
          touchEvent (){
              var scrollTop = this.$el.scrollTop
              var imgHeigth= 300+65 
              var opacityValue=scrollTop/imgHeigth
              document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+','+opacityValue+')'
          },    
          getSiteInfo: function() {
            const ths = this;
            this.$post("/Shop/SiteConfigServer/GetSiteConfig")
            .then(function(res) {
              if (res.IsSuccess) {
                ths.siteInfo = res.Data
                ths.$refs.XRtoast.hide()
              }
            })
            .catch(function(err) {
              console.log(err);
            });
          },  
          getSalesmanInfo(){      
            const ths = this;
            this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
            .then(function(res) {
              if (res.IsSuccess) {  
                ths.isLogin = true        
                ths.indexInfo = res.Data
                if(ths.indexInfo.UserBs == 0){
                  ths.isNotSalesman=true
                }
              }
            })
            .catch(function(err) {
              console.log(err);
            });
          },   
        }
    }
</script>

<style >
  body .openSalesmanShopPage{
    background: #eee;
  }
  .openSalesmanShopPage .XR-head{
    position: fixed;
    background: rgb(0,0,0,0);
    box-shadow: none;
    }
    .openSalesmanShopPage .XR-head .left .mu-icon-button .fa-angle-left {
      background: rgba(71,74,79,0.25);
      border-radius: 50%;
    }
    .openSalesmanShopPage .XR-head .mu-appbar-title span {
      background: rgba(71,74,79,0.25);
      padding: 3px 6px;
      color: #fff;
  }
  .openSalesmanShopPage	.recommend{
    width: 100%;
    height: 60px;
    background: #332C2B;
  }
  .openSalesmanShopPage	.recommend .logo{
    width: 20%;
    height: 100%;
    float: left;
    text-align: center;
  }
  .openSalesmanShopPage	.recommend .logo img{
    height: 70%;
    margin-top: 9px;
  }
  .openSalesmanShopPage	.recommend .invite{
    float: right;
    width: 75%;
    height: 100%;
    padding: 0 4% 0 1%;
    display: flex;
    align-items: center;
  }
  .openSalesmanShopPage	.recommend .invite p{
    margin: 0;
    font-size: 14px;
    color: #fff;
  }
  .openSalesmanShopPage	.preferential{
    width: 100%;
    height: 500px;
    background: url(/static/openSalesmanShop/2.png) no-repeat;
    background-size: 100% 100%;
    top: -1px;
    text-align: center;
    position: relative;
  }
  .openSalesmanShopPage	.preferential p.top{
    margin: 0;
    text-align: center;
    width: 100%;
    font-size: 18px;
    color: #50432A;
    position: absolute;
    top: 8.2%;
    font-weight: 600;
  }
  .openSalesmanShopPage	.preferential p.top span{
    padding: 0 2px;
  }
  .preferential .identity{
    width: 100%;
    text-align: center;
    position: absolute;
    top: 60%;
  }
  .openSalesmanShopPage	.preferential .identity p{
    color: #fff;
    margin: 0;
    font-size: 26px;
    font-weight: 400;
  }
  .openSalesmanShopPage	.preferential .identity p:first-child{
    margin-bottom: 10px;
  }
  .openSalesmanShopPage	.preferential .identity p span.seven{
    color: #FDD100;
    font-weight: bold;
    padding: 0 5px;
  }
  .openSalesmanShopPage	.content{
    background-image: url(/static/openSalesmanShop/3.png);
    background-size: 100% 100%;
    width: 100%;
    text-align: center;
    height: 940px;
    position: relative;
    top: -2px;
  }
  .openSalesmanShopPage	.content .message{
    position: relative;
    top:-10%;
    left: 10%;
    width: 80%;
    height:960px;
    text-align: center;
    margin: 0;
    background: url(/static/openSalesmanShop/4.png) no-repeat;
    background-size:100% 100%;
  }
  .openSalesmanShopPage	.content .message .head{
    position: absolute;
    left: 20%;
    top: 9%;
    width: 60%;
    height: 40px;
    line-height: 30px;
    background: url(/static/openSalesmanShop/1.png) no-repeat;
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit{
    position: absolute;
    left: 5%;			
    width: 90%;
    height: 80px;
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 25%;			
  }
  .openSalesmanShopPage	.content .message .profit p{
    margin: 10% 0 0 0;
  }
  .openSalesmanShopPage	.content .message .profit-one{
    top: 15%;
    background: url(/static/openSalesmanShop/5.png) no-repeat;
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-two{
    top: 27%;
    background: url(/static/openSalesmanShop/6.png);
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-three{
    top: 39%;
    background: url(/static/openSalesmanShop/7.png);
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-four{
    top: 51%;
    background: url(/static/openSalesmanShop/8.png);
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-five{
    top: 63%;
    background: url(/static/openSalesmanShop/9.png);
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-six{
    top:75%;
    background: url(/static/openSalesmanShop/10.png);
    background-size: 100% 100% ;
  }
  .openSalesmanShopPage	.content .message .profit-seven{
    top: 87%;
    background: url(/static/openSalesmanShop/11.png);
    background-size: 100% 100% ;
  }
			
      
  .openSalesmanShopPage .bottom-bar{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 56px;
    border-top:1px solid #eee;
  }
  .openSalesmanShopPage .open-button{
    width: 100%;
    line-height: 56px;
    height: 56px;
    text-align: center;
    background: red;
  }
</style>


// WEBPACK FOOTER //
// src/pages/openSalesmanShop.vue